module.exports = __webpack_public_path__ + "assets/8bb1ed933e533e0b870a519280364f75.jpg";